import { render, staticRenderFns } from "./CompanyBar.vue?vue&type=template&id=450ce134&scoped=true&"
import script from "./CompanyBar.vue?vue&type=script&lang=js&"
export * from "./CompanyBar.vue?vue&type=script&lang=js&"
import style0 from "./CompanyBar.vue?vue&type=style&index=0&id=450ce134&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "450ce134",
  null
  
)

export default component.exports